import useStore from "@store/store";
import { useShallow } from "zustand/react/shallow";
import { images } from "@img/imagesMap";

export const useLoginUser = () => useStore((state) => state.loginUser);
export const useIsAuthenticated = () =>
  useStore((state) => state.isAuthenticated);

// 관리자
export const useIsAdmin = () => {
  const loginUser = useLoginUser();
  return !!(loginUser?.EmpAuthGbn === "ADM" || loginUser?.is_master_admin);
};

// 그룹관리자
export const useIsGroupNurse = () => {
  const loginUser = useLoginUser();
  return loginUser?.hn_auth === "HN";
};

export const useAuthActions = () =>
  useStore(
    useShallow((state) => ({
      setLoginUser: state.setLoginUser,
      logout: state.logout,
    }))
  );

// 프로필 이미지 URL 가져오기
export const useProfileImageUrl = () => {
  const profileImageUrl = useStore((state) => state.profileImageUrl);
  const gender = useStore((state) => state.gender);

  // 프로필 이미지 URL이 있으면 사용, 없으면 gender에 따라 기본 이미지 사용
  if (profileImageUrl) {
    return profileImageUrl;
  }

  return gender === "남" ? images.profile_boy : images.profile_girl;
};

// Deprecated alias - keeping for potential other file usage until fully refactored
export const useUser = useLoginUser;
